<template>
  <material-card
    :title="$t('components.plancreationwizard.plan_settings')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
    style="margin-top: 30px"
  >
    <v-card-text>
      <v-form
        ref="generalSettingsCheckboxes"
        v-model="valid"
        :disabled="disabled"
      >
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasMemberPortal"
              :label="$t('views.plangeneralparameters.has_member_portal')"
            ></v-checkbox>
          </v-col>
          <template v-if="generalSettings.PlanSettings.HasMemberPortal">
            <!-- <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-container pa-0>
                    <v-row no-gutters>
                      <v-col>
                        <v-checkbox
                          v-model="generalSettings.PlanSettings.IsLegacyPortal"
                          :label="
                            $t('views.plangeneralparameters.legacy_portal')
                          "
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        style="margin-top: 20px; margin-left: 3px"
                        cols="auto"
                      >
                        <v-icon v-bind="attrs" v-on="on">help</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <span>
                  {{
                    $t(
                      "components.plancreationwizard.has_member_portal_tooltip"
                    )
                  }}
                </span>
              </v-tooltip>
            </v-col> -->
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <no-autocomplete-textfield
                :label="$t('components.plancreationwizard.portal_domain')"
                v-model="generalSettings.PlanSettings.PortalDomain"
                :rules="[$rules.required, $rules.url]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </template>
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";

export default {
  components: { NoAutocompleteTextfield },
  props: ["generalSettings", "disabled"],
  data() {
    return {
      valid: false,
    };
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    "generalSettings.PlanSettings.HasMemberPortal": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.IsLegacyPortal = false;
          this.generalSettings.PlanSettings.PortalDomain = null;
        }
      },
    },
  },
};
</script>
